import { render, staticRenderFns } from "./PromotionStepCondition.vue?vue&type=template&id=5b45d61c&scoped=true&"
import script from "./PromotionStepCondition.vue?vue&type=script&lang=js&"
export * from "./PromotionStepCondition.vue?vue&type=script&lang=js&"
import style0 from "./PromotionStepCondition.vue?vue&type=style&index=0&id=5b45d61c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b45d61c",
  null
  
)

export default component.exports